import { useRouter } from 'next/router';
import { DidomiSDK } from '@didomi/react';
import didomiConfig from './didomiConfig';
import { useState, useEffect } from 'react';
import excludes from './excludes';
import { getRequiredServices } from '@portal-internet/bff';

export default function AvisCookies(props) {
    const { dataFetchProps, didomiService = ['didomi'] } = props;
    const requiredServices = getRequiredServices(dataFetchProps, didomiService);

    let didomiObject = {};
    const { asPath } = useRouter();
    const [adobeConsent, setAdobeConsent] = useState(false);
    const mostraCMP = !excludes.some((exclude) => asPath.includes(exclude));

    const onDidomiReady = (didomi) => {
        didomiObject = didomi;
        setAdobeConsent(didomiObject.getUserConsentStatusForVendor(565));
    };

    const consentHasChanged = (cwtToken) => {
        setAdobeConsent(didomiObject.getUserConsentStatusForVendor(565));
    };

    const setGlobalEvar = (index, eVar) => {
        window.globalEvars = window.globalEvars || {};
        window.globalEvars[index] = eVar;
    };

    useEffect(() => {
        if (window?.digitalData?.page) {
            window.digitalData.page.consent = adobeConsent ? 'sí' : 'no';
            setGlobalEvar('eVar89', window.digitalData.page.consent);
        }
    }, [adobeConsent]);

    if (!requiredServices?.areAllServicesAvailable) {
        return <></>;
    }

    return mostraCMP ? (
        <DidomiSDK
            iabVersion={2}
            config={didomiConfig}
            noticeId='ZRBgyG7J'
            gdprAppliesGlobally={true}
            onReady={onDidomiReady}
            onConsentChanged={consentHasChanged}
        />
    ) : (
        <></>
    );
}
